module.exports = __webpack_public_path__ + "static/media/im-rahmen1.1aa20e85.png";